const routes = [
  {
    path: "/admin",
    component: () =>
      import(/* webpackChunkName: "admin" */ "@/views/Admin.vue"),
    meta: {
      admin: true,
    },
    children: [
      {
        path: "profile",
        component: () =>
          import(/* webpackChunkName: "admin" */ "@/views/Admin/Profile.vue"),
        children: [
          {
            path: "",
            name: "AdminProfile",
            component: () =>
              import(
                /* webpackChunkName: "admin" */ "@/views/Admin/Profile/List.vue"
              ),
          },
          {
            path: "create",
            name: "AdminProfileCreate",
            component: () =>
              import(
                /* webpackChunkName: "admin" */ "@/views/Admin/Profile/Create.vue"
              ),
          },
          {
            path: ":id",
            name: "AdminProfileEdit",
            component: () =>
              import(
                /* webpackChunkName: "admin" */ "@/views/Admin/Profile/Edit.vue"
              ),
          },
        ],
      },
    ],
  },
];

export default routes;
